import apiClient from './client'
import type { SportType } from '@/types/api'

export const sportTypesApi = {
  // GET /api/v1/sport-types - список видов спорта
  list: async (): Promise<SportType[]> => {
    const response = await apiClient.get<SportType[]>('/sport-types')
    return response.data
  },
}
